import { render, staticRenderFns } from "./PricingCompareModal.vue?vue&type=template&id=afb3b3a6&"
import script from "./PricingCompareModal.vue?vue&type=script&lang=js&"
export * from "./PricingCompareModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports